import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

export function getCaptcha() {
  return request({
    url: '/auth/captcha',
    method: 'post'
  })
}

export function getInfo(token) {
  return request({
    url: '/users/info',
    method: 'post',
    params: { token }
  })
}

// 获取用户列表
export function getUserList(query, data) {
  return request({
    url: '/users/list',
    method: 'post',
    params: query,
    data: data
  })
}

// 添加用户
export function addUser(data) {
  return request({
    url: '/users/add',
    method: 'post',
    data
  })
}

// 修改用户
export function updateUser(data) {
  return request({
    url: '/users/update',
    method: 'post',
    data
  })
}

// 删除用户
export function deleteUser(id) {
  return request({
    url: '/users/delete',
    method: 'post',
    data: { id }
  })
}

// 重置密码（管理员操作）
export function resetPassword(id, newPassword = '123456') {
  return request({
    url: '/users/resetPassword',
    method: 'post',
    data: { id, newPassword }
  })
}

// 修改密码（当前用户）
export function changePassword(oldPassword, newPassword) {
  return request({
    url: '/users/changePassword',
    method: 'post',
    data: { oldPassword, newPassword }
  })
}

// 获取用户角色
export function getUserRoles(userId) {
  return request({
    url: `/user-role/getRoles/${userId}`,
    method: 'post'
  })
}

// 分配用户角色
export function assignUserRoles(userId, roleIds) {
  return request({
    url: '/user-role/saveRole',
    method: 'post',
    data: { userId, roleIds }
  })
}

// 用户注销
export function logout() {
  return request({
    url: '/auth/logout',
    method: 'post'
  })
}
